export const POLLING_INTERVAL = 15000;

export const TEXT_VIEW_ON_EXPLORER = "View on explorer";

export const URL_BOC = 'https://tonkey-boc.netlify.app';
